export const invalidTypes = ['PriceRangeEntrySelection'];
